import { render } from "./ReferralCodes.vue?vue&type=template&id=a27670e8"
import script from "./ReferralCodes.vue?vue&type=script&lang=js"
export * from "./ReferralCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__